export default __webpack_public_path__ + "static/media/bg7.dc09b7b1.jpg";